export default "__VITE_ASSET__B7A6BnRF__"